import { render, staticRenderFns } from "./CourseInfoNotification.vue?vue&type=template&id=12c761e8&"
import script from "./CourseInfoNotification.vue?vue&type=script&lang=js&"
export * from "./CourseInfoNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports